export class MDPhysicallyHandicappedBodyModel {
    constructor(
        public nameAsOnCertificate: string,
        public phDocumentType: string,
        public phDocumentNo: string,
        public disabilityPercentage: number,
    ) { }
}